module.exports = __webpack_public_path__ + "static/media/gledo.91e8f524.png";